module.exports = __webpack_public_path__ + "media/triple.7ae65663.mp4";